// 定义一个异步函数，用于动态加载语言包

export const loadLanguage = async (language) => {
    try {
        // 根据传入的语言参数，动态导入相应的语言包
        const response = await import(`./LanguageJson/${language}.json`);
        // 返回导入的语言包数据
        return response.default;
    } catch (error) {
        // 如果加载语言包时出现错误，打印错误信息
        console.error('Error loading locale:', error);
        // 返回一个空对象
        return {};
    }
};
